import * as React from 'react';
import { Field, Form, Formik } from 'formik';
import { AppUser } from 'Src/views/App/App';
import * as propz from "propz";
import * as Yup from "yup";
import {MAX_NEXT_OF_KIN_PRIORITY, MIN_NEXT_OF_KIN_PRIORITY} from "../../consts/student";
import './StudentNextOfKinForm.css';

interface Props {
    person?: any;
    onSubmit: (data) => void;
    onCancel: () => void;
    user: AppUser;
}

const NextOfKinSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    personEmail: Yup.string().email('Must be valid email')
});

export const StudentNextOfKinForm: React.FunctionComponent<Props> = props => {
    const { person, onSubmit, onCancel } = props;
    const isNextOfKinExist = typeof person !== 'undefined';

    const nextOfKinForm = {
        relationship: isNextOfKinExist ? propz.get(person, ['relationship'], '') : '',
        firstName: isNextOfKinExist ? propz.get(person, ['firstName'], '') : '',
        lastName: isNextOfKinExist ? propz.get(person, ['lastName'], '') : '',
        phones: [
            propz.get(person, ['phones', '0'], ''),
            propz.get(person, ['phones', '1'], '')
        ],
        personEmail: isNextOfKinExist ? propz.get(person, ['email'], ''): '',
        priority: isNextOfKinExist ? propz.get(person, ['priority'], undefined): undefined
    };

    const nextOfKinPriorityOptions = () => {
        let options = [];

        for (let index = MIN_NEXT_OF_KIN_PRIORITY; index <= MAX_NEXT_OF_KIN_PRIORITY; index++) {
            options.push(
                <option key={index} value={index}>
                    {index}
                </option>
            );
        }

        options.unshift(
            <option key={`empty_priority`} value={0}>
                None
            </option>
        );

        return options;
    };

    return (
        <Formik
                        validationSchema={NextOfKinSchema}
                        initialValues={nextOfKinForm}
                        onSubmit={values => {
                            onSubmit(values);
                        }}
                        >
                        {({ touched, errors, setFieldValue, values }) => (
                            <Form className="nextOfKinForm">
                                <p className="nextOfKinForm__intro">Add contact details and define this person's relationship and contact priority.</p>
                                <div className="nextOfKinForm__grid">
                                  <label className="nextOfKinForm__field"><span>Relationship</span><Field type="text" name="relationship" placeholder="e.g. Parent, guardian" />{touched.relationship && errors.relationship ? <em>{String(errors.relationship)}</em> : null}</label>
                                  <label className="nextOfKinForm__field"><span>Priority</span><Field component="select" name="priority">{nextOfKinPriorityOptions()}</Field>{touched.priority && errors.priority ? <em>{String(errors.priority)}</em> : null}</label>
                                  <label className="nextOfKinForm__field"><span>First name <b>*</b></span><Field type="text" name="firstName" />{touched.firstName && errors.firstName ? <em>{String(errors.firstName)}</em> : null}</label>
                                  <label className="nextOfKinForm__field"><span>Last name</span><Field type="text" name="lastName" /></label>
                                  <label className="nextOfKinForm__field nextOfKinForm__field--wide"><span>Email</span><Field type="email" name="personEmail" placeholder="name@example.com" />{touched.personEmail && errors.personEmail ? <em>{String(errors.personEmail)}</em> : null}</label>
                                  <label className="nextOfKinForm__field"><span>Primary phone</span><Field type="tel" value={values.phones[0]} onChange={(event) => {
                                            const currentPhone = event.target.value;
                                            const newPhones = [...values.phones];
                                            newPhones.splice(0, 1, currentPhone);
                                            setFieldValue('phones', newPhones);
                                        }} /></label>
                                  <label className="nextOfKinForm__field"><span>Alternative phone</span><Field type="tel" value={values.phones[1]} onChange={(event) => {
                                    const currentPhone = event.target.value;
                                    const newPhones = [...values.phones];
                                    newPhones.splice(1, 1, currentPhone);
                                    setFieldValue('phones', newPhones);
                                  }} /></label>
                                </div>
                                <div className="nextOfKinForm__actions"><button type="button" className="sit-btn sit-btn--ghost" onClick={onCancel}>Cancel</button><button type="submit" className="sit-btn sit-btn--primary">{isNextOfKinExist ? 'Save changes' : 'Add next of kin'}</button></div>
                            </Form>
                        )}
        </Formik>
    );
};

StudentNextOfKinForm.displayName = 'StudentNextOfKinForm';

